import * as symbols from "../../symbols";

export default function () {
    String.prototype[symbols.isEmpty] = function () {
        return !this || this.length === 0;
    };
}
